export default "__VITE_ASSET__aBMpe5ov__"